angular.module('mychart').controller('ShareCCDCtrl',
    ['$scope', 'PatientPortalStorageRepository', 'ChartRepository', '$sce', '$location', 'toaster', 'aprgettext', '$log', '$uibModal',
        function ($scope, PatientPortalStorageRepository, ChartRepository, $sce, $location, toaster, gettext, $log, $modal) {
            'use strict';

            $scope.loading = true;
            $scope.loadingHtml = false;
            $scope.loadingXml = false;
            $scope.vm = {
                startDate: '',
                endDate: '',
                fullHistory: true
            };           

            var path = $location.path();

            var activePatient = PatientPortalStorageRepository.getActivePatient(),
                loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                },
                ccdHtml;
            $scope.model = {
                chartHtml: '',
                loadingUrl: '',
                xmlFileName: activePatient.firstName + activePatient.lastName + '_CDA.xml',
                ccdFileName: activePatient.firstName + activePatient.lastName + '_CCD.html'
            };

            function downloadCDA() {
                $scope.loadingXml = true;

                var startDate = null;
                var endDate = null;
                
                if (!$scope.vm.fullHistory){
                    startDate = ($scope.vm.startDate) ? moment($scope.vm.startDate).hour(0).minute(0).second(0).toDate() : null;
                    endDate = ($scope.vm.endDate) ? moment($scope.vm.endDate).hour(0).minute(0).second(0).toDate() : null;
                }
                var dateFilter = {
                    startDate: startDate,
                    endDate: endDate
                };

                return ChartRepository.getCDAXml(reportRequestDto.PatientId, dateFilter)
                    .then(function (data) {
                        if (data) {
                            return data.StringResult;
                        }
                    })
                    .catch(function (response) {
                        $log.error(response);
                        toaster.pop('error', '', gettext('An error has occurred. Unable to download CDA.'));
                    })
                    .finally(function () {
                        $scope.loadingXml = false;
                    });
            }

            function downloadHtml() {
                $scope.loadingHtml = true;
                return ChartRepository.postCCDHtmlDownloaded(reportRequestDto)
                    .then(function () {
                        return ccdHtml;
                    })
                    .catch(function (response) {
                        $log.error(response);
                        toaster.pop('error', '', gettext('An error has occurred. Unable to download Html.'));
                    })
                    .finally(function () {
                        $scope.loadingHtml = false;
                    });
            }

            function viewAccessLog() {
                $modal.open({
                    templateUrl: '/mychart/views/modals/ccdAccessLog.html',
                    controller: 'CcdAccessLogModalCtrl',
                    size: 'lg',
                    resolve: {
                        patientId: function () {
                            return activePatient.id;
                        }
                    }
                });
            }

            function transmitModal() {
                var startDate = null;
                var endDate = null;
                
                if (!$scope.vm.fullHistory){
                    startDate = ($scope.vm.startDate) ? moment($scope.vm.startDate).hour(0).minute(0).second(0).toDate() : null;
                    endDate = ($scope.vm.endDate) ? moment($scope.vm.endDate).hour(0).minute(0).second(0).toDate() : null;
                }
                reportRequestDto.startDate = startDate;
                reportRequestDto.endDate = endDate;
                var modalInstance = $modal.open({
                    templateUrl: '/mychart/views/modals/ccdTransmit.html',
                    controller: 'CcdTransmitModalCtrl',
                    size: 'lg',
                    resolve: {
                        requestDto: function () {
                            return reportRequestDto;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    //todo open a success toaster
                });
            }

            function getCcdHtml() {                
                $scope.loadingCcd = true;
                var startDate = null;
                var endDate = null;
                
                if (!$scope.vm.fullHistory){
                    startDate = ($scope.vm.startDate) ? moment($scope.vm.startDate).hour(0).minute(0).second(0).toDate() : null;
                    endDate = ($scope.vm.endDate) ? moment($scope.vm.endDate).hour(0).minute(0).second(0).toDate() : null;
                }
                var dateFilter = {
                    startDate: startDate,
                    endDate: endDate
                };
                ChartRepository.getCCDHtml(reportRequestDto.PatientId, dateFilter)
                .then(function (data) {
                    $scope.removeHttpError();
                    if (data) {
                        ccdHtml = data.StringResult;
                        $scope.model.chartHtml = $sce.trustAsHtml(ccdHtml);
                        var absPath = $location.absUrl(),
                            partial = $location.path(),
                            newPartial = '/loadingDocument/';
                        $scope.model.loadingUrl = absPath.replace(partial, newPartial);
                    }
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                })
                .finally(function () {
                    $scope.loadingCcd = false;
                    $scope.loading = false;
                });
            }
            getCcdHtml();

            $scope.getCcdHtml = getCcdHtml;
            $scope.downloadCDA = downloadCDA;
            $scope.downloadHtml = downloadHtml;
            $scope.viewAccessLog = viewAccessLog;
            $scope.transmitModal = transmitModal;
            $scope.path = path;
        }]);